export function makeViewLink(
  basePath: string | undefined,
  baseViewId: string | undefined,
  customViewId: string | undefined = undefined,
  isDefaultView = true
) {
  const cleanBasePath = basePath === '/' ? '' : basePath || ''
  return isDefaultView
    ? `${cleanBasePath || ''}/view/${customViewId || baseViewId}?ignoreOverrideView`
    : `${cleanBasePath || ''}/view/${baseViewId}/custom/${customViewId}`
}
